module.exports = __webpack_public_path__ + "static/img/cooperate.288e28d8.png";